import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import { useParams } from "react-router-dom";

import { UserDetailsViewModel } from "../../../../viewmodels/setup/users/user/UserDetailsViewModel";
import UserDetailsForm from "../../../../components/forms/user/UserDetailsForm";

function UserDetails(props) {
  const { logout } = props;
  const { userId } = useParams();

  const {
    createUser,
    updateUser,
    getUser,
    user,
    loading,
    changeUserPasswordAdmin,
    getTenantsForDropdown,
    tenants,
  } = UserDetailsViewModel(logout, userId);

  useEffect(() => {
    if (userId) {
      getUser();
    }
    getTenantsForDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">

      <div className="card-custom">
        {loading ? null : (
          <UserDetailsForm
            isEdit={Boolean(userId)}
            user={user}
            actionCall={(values) => {
              if (userId) {
                updateUser(values);
              } else {
                createUser(values);
              }
            }}
            onResetPassword={(payload) => {
              changeUserPasswordAdmin(user.id, payload);
            }}
            tenants={tenants}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserDetails)
);
